export default __webpack_public_path__ + "static/media/unlock-icon.6c65d670.svg";